import React from 'react';
import {useTranslation} from 'yoshi-flow-editor-runtime';
import {useControllerProps} from '../../../ControllerContext';
import {EstimatedTax} from './EstimatedTax/EstimatedTax';
import {OrderSummaryDataHook} from '../OrderSummary';
import s from '../OrderSummary.scss';
import {TotalShipping} from './TotalShipping/TotalShipping';
import {DeliveryMethod} from './DeliveryMethod/DeliveryMethod';
import {DeliveryError} from './DeliveryError/DeliveryError';
import {DeliveryNotification} from './DeliveryNotification/DeliveryNotification';

const FormattedSubTotal = () => {
  const {t} = useTranslation();
  const {formattedItemsTotal} = useControllerProps().cartStore.cart.convertedTotals;

  return (
    <dl>
      <dt>{t('cart.subtotal')}</dt>
      <dd data-hook={OrderSummaryDataHook.SubTotalsValue}>{formattedItemsTotal}</dd>
    </dl>
  );
};

export const SubTotals = () => {
  const {
    shouldDisplayDelivery,
    shouldDisplayDeliveryMethodSelection,
    shouldDisplayTax,
    shouldDisplayDeliveryError,
    isFullAddressRequired,
  } = useControllerProps().orderStore;

  return (
    <div data-hook={OrderSummaryDataHook.SubTotalsRoot} className={s.divider}>
      <FormattedSubTotal />

      {shouldDisplayDelivery && <TotalShipping />}

      {shouldDisplayDeliveryMethodSelection && <DeliveryMethod />}

      {shouldDisplayTax && <EstimatedTax />}

      {shouldDisplayDeliveryError && (isFullAddressRequired ? <DeliveryNotification /> : <DeliveryError />)}
    </div>
  );
};
